import type { SectionTileCategoryLeft1Big } from '#domains/resolver/board-section-data';
import { Tracktor } from 'react-tracktor';

import { IMAGE_SIZE_TWO_THIRD } from '../../BoardImageSizes';
import { BoardSectionItem } from '../BoardSectionItem';
import { BoardSectionItemFeed } from '../Items/BoardSectionItemFeed';
import { BoardSectionTileRow } from '../Tile/TileRow';
import { BoardSectionTileSection } from '../Tile/TileSection';

type Props = {
	boardSectionItems: SectionTileCategoryLeft1Big['items'];
	isHighlightSection?: boolean;
};

export function BoardSectionTileCategoryLeft1({ boardSectionItems }: Props) {
	if (boardSectionItems.right.type === 'empty') {
		return null;
	}

	return (
		<BoardSectionTileSection>
			<BoardSectionTileRow>
				<Tracktor trackingData={{ data: { inSectionPlacement: 0 } }}>
					<BoardSectionItemFeed teasers={boardSectionItems.feedItems} />
				</Tracktor>

				<Tracktor trackingData={{ data: { inSectionPlacement: 1 } }}>
					<BoardSectionItem teaser={boardSectionItems.right} isLarge={true} sizes={IMAGE_SIZE_TWO_THIRD} />
				</Tracktor>
			</BoardSectionTileRow>
		</BoardSectionTileSection>
	);
}
